Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    miniCalendarMonthHeaderFontWeight: 600,
    miniCalendarMonthHeaderFontSize: 20,
    miniCalendarMonthWidth: 280,
    miniCalendarMonthMotionDuration: "200ms",
    miniCalendarMonthMotionFunction: "ease",
    miniCalendarDayOfWeekHeaderFontWeight: 600,
    miniCalendarDayOfWeekHeaderFontSize: 14,
    miniCalendarDayBackgroundColorSelected: tokens.themeActionPrimaryDefault,
    miniCalendarDayBackgroundColorHover: tokens.themeActionPrimaryHover,
    miniCalendarDayBackgroundColorPressed: tokens.themeActionPrimaryPressed,
    miniCalendarDayBackgroundColorHighlighted: tokens.themeDecorativePaletteSubdued,
    miniCalendarDayForegroundColorDefault: tokens.themeInkDefault,
    miniCalendarDayForegroundColorSelected: tokens.themeInkInverse,
    miniCalendarDayForegroundColorHover: tokens.themeInkInverse,
    miniCalendarDayForegroundColorPressed: tokens.themeInkInverse,
    miniCalendarDayForegroundColorDisabled: tokens.themeInkDisabled,
    miniCalendarDayBorderRadius: 4,
    miniCalendarDayMotionDuration: "100ms",
    miniCalendarDayMotionFunction: "ease",
    miniCalendarIndicatorColor: tokens.themeDecorativePaletteDefault,
    miniCalendarIndicatorWidth: 24,
    miniCalendarIndicatorHeight: 2,
    miniCalendarIndicatorBorderRadius: 999,
    miniCalendarIndicatorSpacingVertical: 4,
    miniCalendarSpacingInset: 32,
    miniCalendarSpacingVertical: 8
  }
};